import { Platform, Orientation } from "consts";
import { pickThemeKey, maxWidth } from "utils";

export const ContainerPadding = {
  [maxWidth(1400)]: {
    [Orientation.LANDSCAPE]: "0px 80px",
  },
  [Platform.WEB]: {
    [Orientation.PORTRAIT]: "50px 60px",
  },
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "0 55px 60px",
    [Orientation.LANDSCAPE]: "0 65px 55px",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "0px 20px 80px",
    [Orientation.LANDSCAPE]: "0px 20px 80px",
  },
};

export const LogoHeight = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "0",
    [Orientation.LANDSCAPE]: "0",
  },
};

export const LogoImageMarginTop = {
  [maxWidth(1400)]: {
    [Orientation.LANDSCAPE]: "35",
  },
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "90",
    [Orientation.LANDSCAPE]: "50",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "10",
  },
};

export const LogoImageStyles = {
  [maxWidth(1400)]: {
    [Orientation.LANDSCAPE]: "5",
  },
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "90",
    [Orientation.LANDSCAPE]: "40",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "5",
    [Orientation.LANDSCAPE]: "30",
  },
};

export const SectionTextFont = {
  [maxWidth(1400)]: {
    [Orientation.LANDSCAPE]: "20",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "20",
    [Orientation.LANDSCAPE]: "20",
  },
};

export const SectionTextMaxWidth = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "auto",
    [Orientation.LANDSCAPE]: "auto",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "auto",
    [Orientation.LANDSCAPE]: "auto",
  },
};

export const SectionTextMargin = {
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "40",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "30",
    [Orientation.LANDSCAPE]: "30",
  },
};

export const NavigationButtonWrapper = {
  [Platform.WEB]: {
    [Orientation.LANDSCAPE]: "40",
    [Orientation.PORTRAIT]: "40",
  },
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "30",
    [Orientation.PORTRAIT]: "40",
  },
};

export const NavigationButtonWrapperPaddingVertical = {
  [Platform.AND]: {
    [Orientation.LANDSCAPE]: "11",
    [Orientation.PORTRAIT]: "11",
  },
};

export const NavigationButtonWrapperPaddingHorizontal = {
  [Platform.WEB]: {
    [Orientation.LANDSCAPE]: "120",
  },
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "40",
    [Orientation.PORTRAIT]: "40",
  },
  [Platform.AND]: {
    [Orientation.LANDSCAPE]: "20",
    [Orientation.PORTRAIT]: "20",
  },
};

export const NavigationButtonWrapperBG = {
  [Platform.AND]: {
    [Orientation.LANDSCAPE]: (_, __, theme) =>
      pickThemeKey("nav_background")({ theme }),
    [Orientation.PORTRAIT]: (_, __, theme) =>
      pickThemeKey("nav_background")({ theme }),
  },
};

export const NavigationButtonPadding = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "0",
    [Orientation.LANDSCAPE]: "0",
  },
};

export const NavigationButtonBorderRadius = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "50",
    [Orientation.LANDSCAPE]: "50",
  },
};

export const NavigationButtonSize = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "45",
    [Orientation.LANDSCAPE]: "45",
  },
};

export const ButtonTextVisibility = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "none",
  },
};

export const ButtonImageVisibility = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "flex",
  },
};
